import * as React from "react";
import { branding } from "../config";

const Loading = () => {
    return (
        <div className="loader-wrap">
            <div className="css-loader" style={{ "--loader-color-primary": branding.color }}></div>
        </div>
    );
};

export default Loading;
